export enum GroupDialogMode {
	ADD, EDIT
}
